<template>
  <div
    class="d-flex flex-column align-stretch"
    style="height: 100vh; padding-top: 70px"
  >
    <div class="pa-2">
      <div class="d-flex flex-wrap">
        <v-col cols="12" md="6" class="d-flex align-center gap-12">
          <i class="rd-product-search font-34" style="color: #4a90e2"></i>
          <span>BP Province</span>
          <v-autocomplete
            v-model="provinceId"
            :items="provinceList"
            item-value="PROVINCE_ID"
            item-text="PROVINCE_NAME"
            class="v-select-custom"
            append-icon="mdi-chevron-down"
            placeholder="เลือก"
            dense
            solo
            flat
            hide-details
            @change="changeProvince"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="d-flex align-center gap-12">
          <span>BP District</span>
          <v-autocomplete
            v-model="amphurId"
            :items="amphurList"
            item-value="AMPHUR_ID"
            item-text="AMPHUR_NAME"
            class="v-select-custom"
            append-icon="mdi-chevron-down"
            placeholder="เลือก"
            dense
            solo
            flat
            hide-details
            :disabled="!provinceId"
            @change="changeAmphur"
          ></v-autocomplete>
        </v-col>
        <v-col cols="11" class="d-flex align-center gap-12">
          <v-autocomplete
            v-model="customerId"
            :items="customerList"
            item-value="customer_id"
            item-text="customer_name"
            class="v-select-custom"
            append-icon="mdi-chevron-down"
            placeholder="เลือกร้านค้า"
            dense
            solo
            flat
            hide-details
            :disabled="!provinceId && !amphurId"
            @change="changeCustomer"
          ></v-autocomplete>
        </v-col>
        <v-col cols="1">
          <DrawerFilters
            :customerId="customerId"
            :disabled="!customerId"
            @callbackFilters="callbackFilters"
          />
        </v-col>
      </div>
    </div>

    <div v-if="!customerId" class="box-content-empty">
      <section class="d-flex flex-column align-center justify-center">
        <img class="mb-4" src="/img/icons/find-store.svg" alt="" />
        <span>กรุณาเลือกร้านค้า</span>
      </section>
    </div>

    <div v-else class="box-content">
      <div class="box-content-header">
        <div v-if="customerSelected" class="store-box">
          <v-avatar>
            <img :src="customerSelected.customer_pic" alt="" />
          </v-avatar>
          <div>
            <section class="font-18 font-w-500 mb-2">
              {{ customerSelected.customer_name || '-' }}
            </section>
            <div class="store-box-detail">
              <section>
                <span>BP No. : </span>
                <span class="font-red">
                  {{ customerSelected.BPcode || '-' }}
                </span>
              </section>
              <section>
                <span>BP Province : </span>
                <span class="font-red">
                  {{ customerSelected.provinces || '-' }}
                </span>
              </section>
              <section>
                <span>BP District : </span>
                <span class="font-red">
                  {{ customerSelected.amphur || '-' }}
                </span>
              </section>
            </div>
          </div>
        </div>

        <div class="d-flex justify-space-between py-3">
          <section class="d-flex align-center gap-8">
            <i class="rd-product-file font-28" style="color: #4a90e2"></i>
            <span class="font-18 font-w-500">เก็บราคาตามเป้าหมาย</span>
          </section>
          <section class="font-w-500">
            <span>Total : </span>
            <span>{{ productList.length }} รายการ</span>
          </section>
        </div>

        <div class="mb-4">
          <v-text-field
            v-model="productFilters.search"
            class="v-text-field-custom"
            placeholder="ค้นหาสินค้า"
            append-icon="mdi-magnify"
            solo
            flat
            dense
            hide-details
            @keyup.enter="refreshProductList"
            @click:append="refreshProductList"
          ></v-text-field>
        </div>

        <div class="table-header">
          <section style="flex: 1.5" class="d-flex align-center justify-center">
            <span>ชื่อสินค้า</span>
          </section>
          <section style="flex: 1" class="d-flex align-center justify-center">
            <span>ราคาซื้อเข้า</span>
          </section>
          <section style="flex: 1" class="d-flex align-center justify-center">
            <span>ราคาซื้อออก</span>
          </section>
          <section
            style="flex: 1"
            class="d-flex align-center justify-center flex-column"
          >
            <span>ปริมาณซื้อเข้า</span>
            <span>/ เดือน</span>
          </section>
        </div>
      </div>

      <div
        v-for="(item, index) in productList"
        :key="item.product_id"
        class="table-row"
      >
        <section class="table-row-detail">
          <section title="ชื่อสินค้า" style="flex: 1.5">
            <div class="pa-3">
              <span class="line-clamp-2">
                {{ index + 1 }}. {{ item.name }}</span
              >
            </div>
          </section>
          <section title="ราคาซื้อเข้า" style="flex: 1">
            <div class="pa-3">
              <InputAutoNumeric
                v-model="item.wholesale_price"
                placeholder="0.00"
                prefix="฿"
                @input="(value) => storeValue(item)"
              />
            </div>
          </section>
          <section title="ราคาซื้อออก" style="flex: 1">
            <div class="pa-3">
              <InputAutoNumeric
                v-model="item.retail_price"
                placeholder="0.00"
                prefix="฿"
                @input="(value) => storeValue(item)"
              />
            </div>
          </section>
          <section title="ปริมาณซื้อเข้า" style="flex: 1">
            <div class="d-flex align-center">
              <div class="pa-3" style="width: 100%">
                <InputAutoNumeric
                  v-model="item.stock"
                  placeholder="0"
                  prefix="ถุง"
                  :decimalPlaces="0"
                  @input="(value) => storeValue(item)"
                />
              </div>
              <div class="mx-4">
                <v-icon
                  v-if="item.status"
                  color="#4A90E2"
                  @click="updateStatus(false, item)"
                >
                  mdi-check-circle
                </v-icon>
                <v-icon
                  v-else
                  color="#C4C4C4"
                  @click="updateStatus(true, item)"
                >
                  mdi-check-circle-outline
                </v-icon>
              </div>
            </div>
          </section>
        </section>
        <section
          v-if="isShowProductNote(item) && item.status"
          class="table-row-note"
        >
          <v-icon color="#A9182A" size="13">mdi-information-outline</v-icon>
          <span class="font-12" style="color: #a9182a">
            ราคาสินค้านี้ไม่อยู่ในระดับราคาตลาด
          </span>
        </section>
      </div>

      <infinite-loading
        :identifier="infiniteId"
        @infinite="getDetailTargetByOSR"
      >
        <div slot="no-more"></div>
        <div slot="no-results" class="my-12">ไม่พบข้อมูล</div>
      </infinite-loading>
    </div>

    <div
      class="d-flex justify-space-between align-center pa-4"
      style="box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16)"
    >
      <section>
        <span class="font-18 font-w-500">
          {{ productListSelected.length }} รายการ
        </span>
      </section>
      <DialogCollectTargetPriceConfirm
        :customerId="customerId"
        :tableProductSelect="productListSelected"
        @saveEmit="onSaved"
      >
        <template #activate="{ openDialog }">
          <button
            class="btn-collect-save"
            @click="openDialog"
            :disabled="!customerId"
          >
            บันทึกข้อมูล
          </button>
        </template>
      </DialogCollectTargetPriceConfirm>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import InputAutoNumeric from '@/components/input/InputAutoNumeric.vue'
import DialogCollectTargetPriceConfirm from '@/components/v2/collectTargetPrice/DialogCollectTargetPriceConfirm.vue'
import DrawerFilters from '@/components/v2/collectTargetPrice/DrawerFilters.vue'

export default {
  components: {
    InfiniteLoading,
    InputAutoNumeric,
    DialogCollectTargetPriceConfirm,
    DrawerFilters,
  },
  data() {
    return {
      infiniteId: +new Date(),
      provinceList: [],
      provinceId: null,
      amphurList: [],
      amphurId: null,
      customerList: [],
      customerId: null,
      customerSelected: null,
      productList: [],
      productListSelected: [],
      productFilters: {
        search: '',
        page: 1,
        limit: 10,
        group: [],
        brand: [],
      },
    }
  },
  mounted() {
    this.$store.dispatch('setTitle', 'เก็บราคาตามเป้าหมาย')
    this.getProvinceList()
  },
  methods: {
    callbackFilters(filters) {
      this.productFilters.group = filters.group
      this.productFilters.brand = filters.brand
      this.refreshProductList()
    },
    onSaved() {
      this.productListSelected = []
      this.refreshProductList()
    },
    storeValue(item) {
      if (item.status) {
        // add or update product
        // find index
        const index = this.productListSelected.findIndex(
          (p) => p.product_id === item.product_id,
        )
        if (index === -1) {
          // add product
          this.productListSelected.push(item)
        } else {
          // update product
          this.productListSelected[index] = item
        }
      } else {
        // remove product
        // find index
        const index = this.productListSelected.findIndex(
          (p) => p.product_id === item.product_id,
        )
        if (index > -1) {
          // remove product
          this.productListSelected = this.productListSelected.filter(
            (_, i) => i != index,
          )
        }
      }
    },
    updateStatus(value, item) {
      item.status = value
      this.storeValue(item)
    },
    isShowProductNote(i) {
      if (i.middle_price_in == 0) {
        return false
      } else {
        if (
          parseFloat(i.wholesale_price) < parseFloat(i.min_price_in) ||
          parseFloat(i.wholesale_price) > parseFloat(i.max_price_in)
        ) {
          return true
        } else {
          return false
        }
      }
    },
    async getProvinceList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/provinces`,
          {},
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.provinceList = res.data.provinces
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeProvince() {
      // reset filers
      this.amphurId = null
      this.amphurList = []
      this.customerId = null
      this.customerList = []
      // fetch data
      this.getAmphurList()
      this.getCustomerList()
    },
    async getAmphurList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/amphur`,
          {
            province: this.provinceId,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          this.amphurList = res.data.amphur
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeAmphur() {
      // reset filters
      this.customerId = null
      this.customerList = []
      // fetch data
      this.getCustomerList()
    },
    async getCustomerList() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPINew}/web/?act=list_customer`,
          {
            user_id: this.$store.state.auth.user.id,
            province: this.provinceId,
            amphur: this.amphurId,
            inTarget: 'Y',
          },
        )

        if (res.status === 200) {
          this.customerList = res.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    changeCustomer() {
      // set customer
      if (this.customerId) {
        this.customerSelected = this.customerList.find(
          (item) => item.customer_id === this.customerId,
        )
      } else {
        this.customerSelected = null
      }
      // reset product selected
      this.productListSelected = []
      // reset filters
      this.productFilters.group = []
      this.productFilters.brand = []
      // load product list
      this.refreshProductList()
    },
    refreshProductList() {
      this.productFilters.page = 1
      this.productList = []
      this.infiniteId += 1
    },
    async getDetailTargetByOSR($state) {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/priceandstock/detailTargetByOSR`,
          {
            customer_id: this.customerId,
            search: this.productFilters.search,
            page: this.productFilters.page,
            limit: this.productFilters.limit,
            group_id: this.productFilters.group,
            company_code: this.productFilters.brand,
          },
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          const productList = res.data.items.list.map((item) => {
            // find index
            const index = this.productListSelected.findIndex(
              (p) => p.product_id === item.product_id,
            )
            if (index !== -1) {
              // use product from selected
              return this.productListSelected[index]
            } else {
              // use product from api
              return item
            }
          })
          if (productList.length === 0) {
            $state.complete()
          } else {
            this.productFilters.page += 1
            this.productList.push(...productList)
            $state.loaded()
          }
        }
      } catch (error) {
        console.error(error)
        $state.complete()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.box-content-empty {
  background-color: #e4e7ec;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-content {
  background-color: #fff;
  height: 100%;
  padding-inline: 12px;
  overflow: auto;
}
.box-content-header {
  min-width: 800px;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
  border-top: 1px solid #ccc;
}
.store-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-block: 12px;
  box-shadow: 0px 2px 4px -2px rgba(0, 0, 0, 0.11);
}
.store-box-detail {
  display: flex;
  font-size: 14px;
  gap: 8px;
  & > section:not(:last-child) {
    padding-right: 8px;
    border-right: 1px solid #ccc;
  }
}
.table-header {
  display: flex;
  background-color: #444;
  color: #fff;
  padding-block: 8px;
  border-radius: 8px;
  font-weight: 500;
  & > section:not(:last-child) {
    position: relative;
  }
  & > section:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 10px;
    bottom: 10px;
    width: 1px;
    background-color: #fff;
  }
}
.table-row {
  padding-block: 12px;
  min-width: 800px;
}
.table-row-detail {
  display: flex;
  align-items: center;
}
.table-row-note {
  background-color: #f5e3e5;
  border-radius: 4px;
  padding: 2px 8px;
  text-align: right;
}
.table-list {
  overflow-y: auto;
}
.btn-collect-save {
  background-color: #a9182a;
  color: #fff;
  padding: 8px 32px;
  font-weight: 500;
  border-radius: 8px;
  &:disabled {
    background-color: #999;
    color: #fff;
  }
}
</style>
